// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"Logo_mainImage__1TsDI","logoWrapper":"Logo_logoWrapper__1jCDS"};